import { render, staticRenderFns } from "./PaymentSms.vue?vue&type=template&id=cea629d6&scoped=true"
import script from "./PaymentSms.vue?vue&type=script&lang=js"
export * from "./PaymentSms.vue?vue&type=script&lang=js"
import style0 from "./PaymentSms.vue?vue&type=style&index=0&id=cea629d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea629d6",
  null
  
)

export default component.exports